import { useChatNotifications } from '@/hooks/useChatNotifications';
import ChatDisconnectedAlert from '@/components/ChatDisconnectedAlert';

/** Ativa o hook global de notificações de chat e exibe o alerta de desconexão. */
export default function ChatNotificationsManager() {
  useChatNotifications();
  return <ChatDisconnectedAlert />;
}
